import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    EXPORT_CUSTOMER_REPORT,
    EXPORT_PRODUCT_SALES_REPORT,
    GET_CUSTOMER_REPORT,
    GET_PRODUCT_SALES_REPORT,
    GET_CATEGORY_SALES_REPORT,
    EXPORT_CATEGORY_SALES_REPORT,
    GET_MARKETING_REPORT,
    EXPORT_MARKETING_REPORT,
    GET_SALES_REPORT,
    EXPORT_SALES_REPORT,
} from "./actionTypes.js";

import {
    getCustomerReportSuccess,
    getCustomerReportFail,
    exportCustomerReportSuccess,
    exportCustomerReportFail,
    getProductSalesReportSuccess,
    getProductSalesReportFail,
    exportProductSalesReportSuccess,
    exportProductSalesReportFail,
    getCategorySalesReportSuccess,
    getCategorySalesReportFail,
    exportCategorySalesReportSuccess,
    exportCategorySalesReportFail,
    getMarkettingReportSuccess,
    getMarkettingReportFail,
    exportMarkettingReportSuccess,
    exportMarkettingReportFail,
    getSalesReportSuccess,
    getSalesReportFail,
    exportSalesReportSuccess,
    exportSalesReportFail,
} from "./actions.js"

import { customerReportListing, exportCustomerReportApi, exportProductSalesReportApi, productSalesReportListingApi, categorySalesReportApi, marketingSalesReportApi, exportSalesReportApi, exportMarketingSalesReportApi, exportCategorySalesReportApi, salesReportListing } from "./reportApi.js";

function* fetchSalesReportListing({ payload: payload }) {
    try {
        const response = yield call(salesReportListing, payload)
        yield put(getSalesReportSuccess(response))
    } catch (error) {
        yield put(getSalesReportFail(error))
    }
}

function* exportSalesReport({ payload: payload }) {
    try {
        const response = yield call(exportSalesReportApi, payload)
        yield put(exportSalesReportSuccess(response))
    } catch (error) {
        yield put(exportSalesReportFail(error))
    }
}

function* fetchCustomerReportListing({ payload: payload }) {
    try {
        const response = yield call(customerReportListing, payload)
        yield put(getCustomerReportSuccess(response))
    } catch (error) {
        yield put(getCustomerReportFail(error))
    }
}

function* exportCustomerReport({ payload: payload }) {
    try {
        const response = yield call(exportCustomerReportApi, payload)
        yield put(exportCustomerReportSuccess(response))
    } catch (error) {
        yield put(exportCustomerReportFail(error))
    }
}

function* fetchProductSalesListing({ payload: payload }) {
    try {
        const response = yield call(productSalesReportListingApi, payload)
        yield put(getProductSalesReportSuccess(response))
    } catch (error) {
        yield put(getProductSalesReportFail(error))
    }
}

function* exportProductSalesReport({ payload: payload }) {
    try {
        const response = yield call(exportProductSalesReportApi, payload)
        yield put(exportProductSalesReportSuccess(response))
    } catch (error) {
        yield put(exportProductSalesReportFail(error))
    }
}

function* fetchCategorySalesListing({ payload: payload }) {
    try {
        const response = yield call(categorySalesReportApi, payload)
        yield put(getCategorySalesReportSuccess(response))
    } catch (error) {
        yield put(getCategorySalesReportFail(error))
    }
}

function* exportCategorySales({ payload: payload }) {
    try {
        const response = yield call(exportCategorySalesReportApi, payload)
        yield put(exportCategorySalesReportSuccess(response))
    } catch (error) {
        yield put(exportCategorySalesReportFail(error))
    }
}

function* fetchMarketingReportListing({ payload: payload }) {
    try {
        const response = yield call(marketingSalesReportApi, payload)
        yield put(getMarkettingReportSuccess(response))
    } catch (error) {
        yield put(getMarkettingReportFail(error))
    }
}

function* exportMarketingReport({ payload: payload }) {
    try {
        const response = yield call(exportMarketingSalesReportApi, payload)
        yield put(exportMarkettingReportSuccess(response))
    } catch (error) {
        yield put(exportMarkettingReportFail(error))
    }
}

function* ReportSaga() {
    yield takeEvery(GET_SALES_REPORT, fetchSalesReportListing)
    yield takeEvery(EXPORT_SALES_REPORT, exportSalesReport)
    yield takeEvery(GET_CUSTOMER_REPORT, fetchCustomerReportListing)
    yield takeEvery(EXPORT_CUSTOMER_REPORT, exportCustomerReport)
    yield takeEvery(GET_PRODUCT_SALES_REPORT, fetchProductSalesListing)
    yield takeEvery(EXPORT_PRODUCT_SALES_REPORT, exportProductSalesReport)
    yield takeEvery(GET_CATEGORY_SALES_REPORT, fetchCategorySalesListing)
    yield takeEvery(EXPORT_CATEGORY_SALES_REPORT, exportCategorySales)
    yield takeEvery(GET_MARKETING_REPORT, fetchMarketingReportListing)
    yield takeEvery(EXPORT_MARKETING_REPORT, exportMarketingReport)
}

export default ReportSaga
